module.exports = __webpack_public_path__ + "img/III-27.1.3b0b87b9.svg";